import React from 'react';
import { GiftStatusIcon } from './RetentionGiftVisuals';

const RetentionGiftTimeline = ({ firstDate, targetDate, t }) => (
  <div className="t-mt-5 t-border-0 t-border-t t-border-solid t-border-navy/[0.14] t-pt-4 t-text-left">
    <p className="t-m-0 t-mb-3 t-text-[11px] t-font-bold t-uppercase t-leading-[normal] t-tracking-[0.06em] t-opacity-65">
      {t('RetentionGift_TimelineTitle')}
    </p>
    <ol className="t-m-0 t-flex t-list-none t-items-start t-p-0">
      <li className="t-relative t-min-w-0 t-flex-1 t-pr-2 t-pt-[34px] before:t-absolute before:t-left-[30px] before:t-right-1.5 before:t-top-[11px] before:t-h-0.5 before:t-bg-[repeating-linear-gradient(90deg,#C7D3D1_0_4px,transparent_4px_8px)] before:t-content-['']">
        <span
          aria-hidden="true"
          className="t-absolute t-left-0 t-top-0 t-grid t-h-6 t-w-6 t-place-items-center t-rounded-full t-border-2 t-border-solid t-border-navy t-bg-navy"
        >
          <span className="t-h-2 t-w-2 t-rounded-full t-bg-butter" />
        </span>
        <small className="t-mb-px t-block t-text-[10.5px] t-font-bold t-uppercase t-leading-4 t-tracking-[0.04em] t-text-[#7C8E93]">
          {t('RetentionGift_Today')}
        </small>
        <b className="t-block t-text-[13px] t-leading-[1.25]">{t('RetentionGift_YouAreHere')}</b>
      </li>
      <li className="t-relative t-min-w-0 t-flex-1 t-pr-2 t-pt-[34px] before:t-absolute before:t-left-[30px] before:t-right-1.5 before:t-top-[11px] before:t-h-0.5 before:t-bg-[#DCE4E2] before:t-content-['']">
        <span className="t-absolute t-left-0 t-top-0 t-grid t-h-6 t-w-6 t-place-items-center t-rounded-full t-border-2 t-border-solid t-border-quiz-teal t-bg-white t-text-quiz-teal">
          <GiftStatusIcon type="renewal" className="t-h-3 t-w-3" />
        </span>
        <small className="t-mb-px t-block t-text-[10.5px] t-font-bold t-uppercase t-leading-4 t-tracking-[0.04em] t-text-[#7C8E93]">
          {firstDate || t('RetentionGift_DatePending')}
        </small>
        <b className="t-block t-text-[13px] t-leading-[1.25]">{t('RetentionGift_Renewal')}</b>
        <span className="t-mt-0.5 t-block t-text-xs t-leading-[1.35] t-text-[#4A5F66]">
          {t('RetentionGift_DeliveryPrepared')}
        </span>
      </li>
      <li className="t-relative t-max-w-[42%] t-flex-none t-pr-2 t-pt-[34px]">
        <span className="t-absolute t-left-0 t-top-0 t-grid t-h-6 t-w-6 t-place-items-center t-rounded-full t-border-2 t-border-solid t-border-[#D9C41F] t-bg-white t-text-quiz-teal t-shadow-[0_0_0_3px_rgba(246,225,71,0.5)]">
          <GiftStatusIcon type="renewal" className="t-h-3 t-w-3" />
        </span>
        <small className="t-mb-px t-block t-text-[10.5px] t-font-bold t-uppercase t-leading-4 t-tracking-[0.04em] t-text-[#7C8E93]">
          {targetDate || t('RetentionGift_DatePending')}
        </small>
        <b className="t-flex t-flex-wrap t-items-center t-gap-1 t-text-[13px] t-leading-[1.25]">
          {t('RetentionGift_Renewal')}
          <span className="t-inline-block t-rounded-full t-bg-butter t-px-1.5 t-py-px t-text-[9.5px] t-font-extrabold t-uppercase t-tracking-[0.04em]">
            {t('RetentionGift_WithGift')}
          </span>
        </b>
        <span className="t-mt-0.5 t-block t-text-xs t-leading-[1.35] t-text-[#4A5F66]">
          {t('RetentionGift_DeliveryIncludesGift')}
        </span>
      </li>
    </ol>
  </div>
);

export default RetentionGiftTimeline;
